<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header text-center">
        <h3 class="text-center">Descargar excel de ventas por artículo</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        class="modal-body justify-content-center"
        style="max-height:100%!important;height:auto!important;overflow:visible;"
      >
        <div class="row w-100">
          <float-label label="Desde:" clase="col-md-6 col-12">
            <input
              v-model="desde"
              id="desde"
              type="date"
              class="form-control"
              :class="(enviado && !$v.desde.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.desde.required"
              >Debe seleccionar la fecha</div>
            </template>
          </float-label>
          <float-label label="Hasta:" clase="col-md-6 col-12">
            <input
              v-model="hasta"
              id="hasta"
              type="date"
              class="form-control"
              :class="(enviado && !$v.hasta.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.hasta.required"
              >Debe seleccionar la fecha</div>
            </template>
          </float-label>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="row w-100">
          <div class="col-md-4">
            <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
          </div>
          <div class="col-md-4 offset-md-4">
            <button class="btn btn-info btn-block mb-2" @click="mostrarPDF">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import moment from 'moment';
export default {
  name: "modalExcelVentasPorArticulo",
  components: {
    MyModal,
    FloatLabel
  },
  data() {
    return {
      desde: null,
      hasta: null,
      enviado: false
    };
  },
  validations: {
    desde: { required },
    hasta: { required }
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  mounted() {
    this.hasta = moment().format('Y-MM-DD');
    this.desde = moment().subtract(1, 'days').format('Y-MM-DD');
  },
  methods: {
    mostrarPDF() {
      this.$v.$touch();
      this.enviado = true;
      if (this.$v.$invalid) {
        return false;
      }
      let url =
        axios.defaults.baseURL +
        "/imprimir/ventas-por-vendedor-y-cliente?desde="+this.desde+"&hasta="+this.hasta;
      window.open(url);
      this.$emit("cerrar");
    },
    cerrarModal() {
      this.$emit("cerrar");
    },
  }
};
</script>
